import React, { FC, useEffect, useState } from 'react';
import { GoogleMap, GoogleMapCoord } from '../../../components/GoogleMap';
import { useMappableVenues } from '../providers/MappableVenuesProvider';
import { useFilteredSearchResults } from '../providers/FilteredSearchResultsProvider';

interface SearchGoogleMapProps {
  mapStyle: { [key: string]: string };
  onBoundsChange?: (bounds: { sw: GoogleMapCoord; ne: GoogleMapCoord }) => void;
  viewport?: { sw: GoogleMapCoord; ne: GoogleMapCoord } | null;
}

export const SearchGoogleMap: FC<SearchGoogleMapProps> = ({
  mapStyle,
  onBoundsChange,
  viewport,
}: SearchGoogleMapProps) => {
  const { hoveredSearchResult } = useFilteredSearchResults();
  const { mappableVenues: mappableItems } = useMappableVenues();
  const [map, setMap] = useState<google.maps.Map>();

  const handleBoundsChange = (map: google.maps.Map) => {
    const newBounds = map.getBounds();
    if (newBounds && onBoundsChange) {
      onBoundsChange({
        sw: {
          lat: newBounds.getSouthWest().lat(),
          lng: newBounds.getSouthWest().lng(),
        },
        ne: {
          lat: newBounds.getNorthEast().lat(),
          lng: newBounds.getNorthEast().lng(),
        },
      });
    }
  };
  useEffect(() => {
    if (viewport && map) {
      const bounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(viewport.sw.lat, viewport.sw.lng),
        new google.maps.LatLng(viewport.ne.lat, viewport.ne.lng),
      );
      map.fitBounds(bounds);
    }
  }, [viewport, map]);

  const handleLoad = (map: google.maps.Map) => {
    setMap(map);

    if (onBoundsChange) {
      map.addListener('bounds_changed', () => {
        handleBoundsChange(map);
      });
    }
  };

  return (
    <GoogleMap
      mapStyle={mapStyle}
      mappableItems={mappableItems}
      handleLoad={handleLoad}
      hoveredItemKey={hoveredSearchResult?.id}
    />
  );
};
